import { ProjectMethodologyEnum } from 'gql/graphql';

import { CatalogVariablesOtherTab } from './types';
import type { CatalogVariablesOtherMethodologyItem, CatalogVariablesOtherTabItem } from './types';

export const CATALOG_VARIABLES_OTHER_NAME = 'Справочник переменных для формул прочих и лимитированных затрат';

export const CATALOG_VARIABLES_OTHER_TABS: CatalogVariablesOtherTabItem[] = [
    {
        id: CatalogVariablesOtherTab.Global,
        label: 'Глобальные переменные',
    },
    {
        id: CatalogVariablesOtherTab.Local,
        label: 'Локальные переменные ДО',
    },
];

export const CATALOG_VARIABLES_OTHER_METHODOLOGY_ITEMS: CatalogVariablesOtherMethodologyItem[] = [
    {
        label: 'УЕР',
        value: ProjectMethodologyEnum.Uer,
    },
    {
        label: 'БИМ',
        value: ProjectMethodologyEnum.Bim,
    },
];
